import { useEffect, useRef, useState } from "react";
import { QrCode } from "lucide-react";

const FAMILY = { sans: "Arial, Helvetica, sans-serif", serif: "'Times New Roman', Times, serif", mono: "'Courier New', monospace" };
const SAMPLE = { name_box: "Participant Full Name", serial_box: "" };

const useWidth = (ref) => {
  const [w, setW] = useState(0);
  useEffect(() => {
    const ro = new ResizeObserver(([e]) => setW(e.contentRect.width));
    if (ref.current) { ro.observe(ref.current); }
    return () => ro.disconnect();
  }, [ref]);
  return w;
};

const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));

export const CertCanvas = ({ t, selected, onSelect, onMove }) => {
  const ref = useRef(null);
  const W = useWidth(ref);
  const H = t.width ? (W * t.height) / t.width : 0;
  const drag = (key) => (ev) => {
    ev.preventDefault();
    onSelect(key);
    const start = { x: ev.clientX, y: ev.clientY, bx: t[key].x, by: t[key].y };
    const move = (m) => onMove(key, { x: clamp(start.bx + (m.clientX - start.x) / W, 0, 0.98), y: clamp(start.by + (m.clientY - start.y) / H, 0, 0.98) });
    const up = () => { window.removeEventListener("pointermove", move); window.removeEventListener("pointerup", up); };
    window.addEventListener("pointermove", move);
    window.addEventListener("pointerup", up);
  };
  const ring = (key) => (selected === key ? "ring-2 ring-[#E60000]" : "ring-1 ring-dashed ring-gray-500/70 hover:ring-[#E60000]");
  const textBox = (key, text, testId) => {
    const b = t[key];
    return (
      <div onPointerDown={drag(key)} data-testid={testId} className={`absolute cursor-move select-none touch-none bg-white/30 overflow-hidden whitespace-nowrap ${ring(key)}`}
        style={{ left: `${b.x * 100}%`, top: `${b.y * 100}%`, width: `${b.w * 100}%`, fontSize: `${b.size * H}px`, lineHeight: 1.15, color: b.color, fontFamily: FAMILY[b.font],
          fontWeight: b.style === "bold" ? 700 : 400, fontStyle: b.style === "italic" ? "italic" : "normal", textAlign: b.align }}>{text}</div>
    );
  };
  const q = t.qr_box;
  return (
    <div ref={ref} className="relative w-full shadow-xl bg-white" data-testid="cert-canvas">
      <img src={`${process.env.REACT_APP_BACKEND_URL}${t.image_url}`} alt="Certificate template" className="w-full block pointer-events-none" draggable={false} />
      {W > 0 && <>
        {textBox("name_box", SAMPLE.name_box, "cert-box-name")}
        {textBox("serial_box", `${t.code || "CODE"}-0001`, "cert-box-serial")}
        <div onPointerDown={drag("qr_box")} data-testid="cert-box-qr" className={`absolute cursor-move touch-none bg-white grid place-items-center ${ring("qr_box")}`}
          style={{ left: `${q.x * 100}%`, top: `${q.y * 100}%`, width: `${q.size * W}px`, height: `${q.size * W}px` }}>
          <QrCode className="w-3/4 h-3/4 text-[#111]" />
        </div>
      </>}
    </div>
  );
};
